<template>
  <div v-if="show">
    <input
        v-model="formData.title"
        type="text"
        :class="['form-control', { 'is-invalid': error && isDirty }]"
        placeholder="Заголовок"
        @input="handleInput"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @change="changeItem"
    >
    <div v-if="error && isDirty" class="invalid-feedback">
      {{ error }}
    </div>
  </div>
</template>

<script setup>
import { defineOptions, reactive, ref, watch, inject, onUnmounted } from "vue"

defineOptions({
  name: "WishlistTitleWish"
})

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(["onChange"])
const show = ref(true)
const formData = reactive({
  title: null,
})

const error = ref(null)
const isDirty = ref(false)
const isInitialized = ref(false)
const isFocused = ref(false)
const FIELD_ID = "wish_title"

const validationForm = inject("wishlist-form-validation", null)

function validate() {
  const value = formData.title ? formData.title.trim() : ""

  if (!value) {
    error.value = "Заголовок не может быть пустым"
  } else if (value.length < 3) {
    error.value = "Заголовок должен содержать минимум 3 символа"
  } else {
    error.value = null
  }

  if (validationForm) {
    const isValid = !error.value
    validationForm.setFieldError(FIELD_ID, isValid, error.value)
  }
}

function handleInput() {
  isDirty.value = true
  validate()
}

function updateFormData(query) {
  if (!query) return

  // Условие 1: Это самая первая загрузка компонента (инициализация из API)
  // Условие 2: Либо компонент уже загружен, но пользователь НЕ пишет в него сейчас,
  // а данные в родителе изменились по какой-то внешней причине
  if (!isInitialized.value || (!isFocused.value && query.title !== formData.title)) {
    formData.title = query.title ?? ""
    isInitialized.value = true
    validate()
  }
}

watch(
    () => props.payload,
    (newPayload) => {
      updateFormData(newPayload)
    },
    { immediate: true, deep: true }
)

function changeItem(e) {
  emit("onChange", e.target.value)
}

onUnmounted(() => {
  if (validationForm) {
    validationForm.unregisterField(FIELD_ID)
  }
})
</script>
